module.exports = __webpack_public_path__ + "static/img/pingTaiBox3.0b6987d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pingTaiBox3.png
// module id = +DJT
// module chunks = 2